// We pass axios here in order to be able to mock it in other stacks
import axios, { AxiosError, AxiosInstance } from 'axios';
import { serializeError } from '../logging/serializeError';

/*
 * An AxiosError carries the whole request in `config` (auth headers, API
 * keys, bodies). Anything that JSON.stringifies one, e.g. the Lambda
 * runtime's own "Invoke Error" log for an unhandled error, would write those
 * credentials to the logs. `toJSON` is replaced with the credential-free
 * serialisation the Logger uses; `config` itself stays for axios-retry.
 */
const scrubErrorJson = (error: any) => {
  if (error?.isAxiosError === true) {
    // eslint-disable-next-line no-param-reassign
    (error as AxiosError).toJSON = () => serializeError(error);
  }

  return Promise.reject(error);
};

// Other stacks mock axios with a bare object, so only patch what's there
const withScrubbedErrors = (instance: AxiosInstance) => {
  instance?.interceptors?.response?.use(undefined, scrubErrorJson);

  return instance;
};

withScrubbedErrors(axios);

if (typeof axios.create === 'function') {
  const create = axios.create.bind(axios);

  axios.create = (config) => withScrubbedErrors(create(config));
}

export * from 'axios';
export default axios;
